
import store from './store/index';
const toCheckInfo=(cart_hash)=>{
    if(cart_hash){
        window.open(`/checkouts/${cart_hash}`, "_self");
    }else{
        window.open(`/checkouts?step=contact_information`, "_self");
    }
}
const replaceSearch=(name,value)=>{
    let location=window.location;
    let newhref=null;
    const re = new RegExp(name + '=[^&]*', 'gi')
    if(location.search&&location.search.includes(name)){
      newhref=location.search.replace(re, name + '=' + value);
    }else if(location.search){
       newhref=location.search+`&${name}=${value}`;
    }else{
       newhref=`?${name}=${value}`;
    }
    return location.pathname+newhref;
}
const getCookie = (key) => {
    let cookie = document.cookie;
    let value = null;
    if (cookie) {
        let cookie_arr = cookie.split(";");
        cookie_arr.some((item) => {
            if (item.includes(key)) {
                let item_arr = item.split("=");
                if ((item_arr.length = 2)) {
                    value = item_arr[1];
                    return true;
                }
            }
        });
    }
    // if(!value){
    //     try {
    //         let res=await axios.get(API.cart_hash);
    //         console.log(res.data);
    //         value=res.data.cart_hash;
    //     } catch (error) {
    //         return value;
    //     }
    // }
    return value;
}
// 获取查询参数,接收参数作为变量，返回参数=号后的值
const getSearch = (search)=>{
    let search_data=window.location.search;
    let res=null;
    if(search_data&&search_data.split('?').length){
       search_data.split('?')[1].split('&').some(item=>{
          if(item.includes(search)){
              res= item.split('=')[1];
              return true;
          }
        })
    }
    return res;
}
// 拼接国家，部分国家需要替换省份时使用。
const concatCounty =(service,newCountry)=>{
    newCountry.forEach(item=>{
        service.some(serviceItem=>{
            if(item.iso2==serviceItem.code){
                serviceItem.states=[];
                item.states.forEach(element => {
                        serviceItem.states.push({
                            name:element.name,
                            code:element.name
                        })
                });
                return true;
            }
        })
    })
    return service;
}
//展示货币格式
const computePrice = (num,disable_select,country, places, thousand, decimal) => {
    // disable_select禁止选择为true时候应直接使用传入的价格，
    // 但禁止选择为true并且传入国家时候应该乘这个国家的汇率
    if(!disable_select){
        num = store.state.rates[store.state.pricetype] * num;
    }else if(country){
        num = store.state.rates[country] * num;
    }
   
    num = num || 0;
    if((store.state.pricetype=='JPY'&&!disable_select)||(disable_select&&(localStorage.getItem('checkoutcurrency')=="JPY"||country=='JPY'))){
        places=0;
    }
    places = !isNaN(places = Math.abs(places)) ? places : 2;
    thousand = thousand || ",";
    decimal = decimal || ".";
    var negative = num < 0 ? "-" : "",
        i = parseInt(num = Math.abs(+num || 0).toFixed(places), 10) + "",
        a=0,
        j = (a = i.length) > 3 ? a % 3 : 0;
    return  negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(num - i).toFixed(places).slice(2) : "");
};

const initFBevent = (pixel_conversion, product_category_ids) => {
    pixel_conversion.forEach((item) => {
        if (item.type == "category" && product_category_ids.includes(parseInt(item.category_id))) {
            fbq("init", item.pixel_id);
            fbq("track", "PageView");
        }
    });
}
const FBevent = () => {
    ! function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ?
                n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s)
    }(window, document, 'script',
        'https://connect.facebook.net/en_US/fbevents.js');
};
const FbAddToCart = function (product,addproduct) {
    let content_category = [];
    let currency=localStorage.getItem('checkoutcurrency');
    if (product.categories && product.categories.length) {
        product.categories.forEach((item) => {
            content_category.push(item.name);
        });
    }
    window.fbq("track", "AddToCart", {
        content_type: "product_group",
        content_ids: [addproduct.product_id],
        value: product.price,
        num_items: addproduct.quantity,
        content_name: product.title,
        currency,
        content_category,
    });
}
const getcountry = function (country, service) {
    let name = null;
    service.some(item => {
        if (item.code == country) {
            name = item.name
            return true;
        }
    });
    return name;
};
const getstate = function (state, country, service) {
    let province = null;
    service.some(item => {
        if (item.code == country) {
            item.states.some(subitem => {
                if (state == subitem.code) {
                    province = subitem.name;
                    return true;
                }
            })
            return true;
        }
    });
    return province;
};
const imageFailure = function (e, defaultImage) {
    console.log('图片加载失败', e);
    e.target.src = defaultImage;
    e.target.srcset = defaultImage;
}

export default {
    toCheckInfo,
    FbAddToCart,
    replaceSearch,
    getCookie,
    getSearch,
    computePrice,
    initFBevent,
    FBevent,
    getcountry,
    getstate,
    imageFailure,
    concatCounty
}